import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const createLead = (payload) => apiClient.post("/leads", payload).then((r) => r.data);
export const listLeads = () => apiClient.get("/leads").then((r) => r.data);
export const getLeadStats = () => apiClient.get("/leads/stats").then((r) => r.data);
